
export const  User = [
    {
        id:1,
        profile_pic:"person/1.jpeg",
        username:"Nithees Kumar"
    },
    {
        id:2,
        profile_pic:"person/2.jpeg",
        username:"Kural arasu"
    },
    {
        id:3,
        profile_pic:"person/3.jpeg",
        username:"Hari prasad"
    },
    {
        id:4,
        profile_pic:"person/4.jpeg",
        username:"Lokesh singh"
    },
    {
        id:5,
        profile_pic:"person/5.jpeg",
        username:"Aravindh It"
    },
    {
        id:6,
        profile_pic:"person/6.jpeg",
        username:"Karthik raja"
    },
    {
        id:7,
        profile_pic:"person/7.jpeg",
        username:"Anwar Wasim"
    },
    {
        id:8,
        profile_pic:"person/9.jpeg",
        username:"Elavarasan"
    },
    {
        id:9,
        profile_pic:"person/8.jpeg",
        username:"Nithees Kumar"
    },
    {
        id:10,
        profile_pic:"person/10.jpeg",
        username:"Gokul"
    },
]

export const Posts = [
    {
        id:1,
        desc:"All is well",
        photo:"post/1.jpeg",
        date:"5 mins ago",
        userId:1,
        like:32,
        comment:10,
    },
    {
        id:2,
        desc:"there i a will",
        photo:"post/2.jpeg",
        userId:2,
        like:3,
        date:"10 mins ago",
        comment:12,
    },
    {
        id:3,
        desc:"All is well",
        photo:"post/3.jpeg",
        userId:3,
        like:23,
        comment:20,
        date:"15 mins ago",
    },
    {
        id:4,
        desc:"All is well",
        photo:"post/4.jpeg",
        userId:4,
        like:32,
        comment:10,
        date:"20 mins ago",
    },
    {
        id:5,
        desc:"All is well",
        photo:"post/5.jpeg",
        userId:5,
        like:32,
        comment:10,
        date:"25 mins ago",
    },
    {
        id:6,
        desc:"All is well",
        photo:"post/6.jpeg",
        userId:6,
        like:32,
        comment:10,
        date:"30 mins ago",
    },
    {
        id:7,
        desc:"All is well",
        photo:"post/7.jpeg",
        userId:7,
        like:32,
        comment:10,
        date:"35 mins ago",
    },
    {
        id:8,
        desc:"All is well",
        photo:"post/8.jpeg",
        userId:8,
        like:32,
        comment:10,
        date:"45 mins ago",
    },
    {
        id:9,
        desc:"All is well",
        photo:"post/9.jpeg",
        userId:9,
        like:32,
        date:"1 hour ago",
        comment:10,
    },
    {
        id:10,
        desc:"All is well",
        photo:"post/10.jpeg",
        userId:10,
        like:32,
        date:"1 days ago",
        comment:10,
    },
]